export default __webpack_public_path__ + "static/media/1819.9c8f63dc.png";